// extracted by mini-css-extract-plugin
export default {"backBtn":"MessagesTopicView_backBtn__CVLpk","header":"MessagesTopicView_header__hFGap","topicBtn":"MessagesTopicView_topicBtn__RKu53","disabled":"MessagesTopicView_disabled__ccfA8"};